/** Branch column cell — matches Employee List temp-transfer styling. */
export const BranchCell = ({ record }) => {
    const transferredName =
        record?.transfer_branch?.name ||
        record?.effective_branch?.name ||
        record?.branch_id?.[0]?.name ||
        record?.branch;
    const homeName = record?.home_branch?.name;

    if (record?.on_temp_transfer && transferredName) {
        return (
            <span className="inline-flex flex-col gap-0.5">
                <span className="inline-flex items-center gap-1">
                    {transferredName}
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300">
                        Temp
                    </span>
                </span>
                {homeName && homeName !== transferredName && (
                    <span className="text-[10px] text-gray-400 dark:text-gray-500">
                        Home: {homeName}
                    </span>
                )}
            </span>
        );
    }

    return homeName || transferredName || "-";
};

export const TempTransferBadge = () => (
    <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300 shrink-0">
        Temp
    </span>
);
